<script>
  // Self-contained drag-drop photo input with preview, for a one-off photo that goes
  // straight to a presigned upload. Deliberately not ImageUploadDrawer/ImageSelector —
  // those create tagged image-library records, the wrong altitude here.
  //
  // An oversize pick is reported through `ontoolarge` and a wrong type / several files
  // through `onrejected`; neither is accepted.
  import { Button } from './ui'

  const DEFAULT_ACCEPT = ['image/jpeg', 'image/png']

  let {
    file = $bindable(null),
    label,
    accept = DEFAULT_ACCEPT,
    maxBytes = null,
    disabled = false,
    ontoolarge,
    onrejected
  } = $props()

  let dragging = $state(false)
  let previewUrl = $state(null)

  $effect(() => {
    if (!file) return
    const url = URL.createObjectURL(file)
    previewUrl = url
    return () => {
      previewUrl = null
      URL.revokeObjectURL(url)
    }
  })

  const pick = (files) => {
    if (!files || files.length === 0) return
    const picked = files[0]
    if (files.length > 1 || !accept.includes(picked.type)) {
      onrejected?.(picked)
      return
    }
    if (maxBytes && picked.size > maxBytes) {
      ontoolarge?.(picked)
      return
    }
    file = picked
  }

  const onPicked = (event) => {
    pick(event.target.files)
    event.target.value = ''
  }

  const onDropped = (event) => {
    event.preventDefault()
    dragging = false
    if (!disabled) pick(event.dataTransfer?.files)
  }
</script>

<fieldset class="fieldset">
  {#if label}<legend class="fieldset-legend">{label}</legend>{/if}
  {#if file && previewUrl}
    <div class="flex items-center gap-3">
      <img src={previewUrl} alt={label || 'Selected photo'} class="h-18 w-18 object-cover rounded-box" />
      <span class="flex-1 text-sm break-all">{file.name}</span>
      <Button variant="default" size="xs" {disabled} onclick={() => (file = null)}>Remove</Button>
    </div>
  {:else}
    <label
      class="block p-4 text-center text-sm text-base-content/60 border-2 border-dashed rounded-box {disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} {dragging ? 'border-primary bg-primary/10' : 'border-base-300'}"
      ondragover={(event) => {
        event.preventDefault()
        if (!disabled) dragging = true
      }}
      ondragleave={() => (dragging = false)}
      ondrop={onDropped}
    >
      Drag a JPEG/PNG here, or click to browse
      <input type="file" accept={accept.join(',')} class="hidden" {disabled} onchange={onPicked} />
    </label>
  {/if}
</fieldset>
